import React from 'react'
import PropTypes from 'prop-types'

// Horizontal tab nav (replaces the old left-sidebar), styled with Tailwind.
// Render inside a `.cbs-scope` wrapper so the Tailwind border defaults apply.
// Each tab keeps its data-cy so the cypress nav specs continue to work.
const TabNav = ({ tabs }) => (
  <nav className="mb-6 flex flex-wrap gap-1 border-b border-gray-200">
    {tabs.map((tab) => (
      <button
        key={tab.key}
        type="button"
        data-cy={tab.dataCy}
        onClick={tab.onClick}
        className={`-mb-px cursor-pointer border-b-2 px-4 py-2 text-sm font-medium ${
          tab.active
            ? 'border-indigo-600 text-indigo-600'
            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
        }`}
      >
        {tab.label}
      </button>
    ))}
  </nav>
)

TabNav.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      onClick: PropTypes.func.isRequired,
      active: PropTypes.bool,
      dataCy: PropTypes.string,
    }),
  ).isRequired,
}

export default TabNav
